import { createFileRoute } from "@tanstack/react-router";
import LandingPage from "@/pages/LandingPage";
import { landingPages } from "@/data/landingPages";
import { landingSchemas, pageHead } from "@/lib/seo";

const c = landingPages["ai-marketing"]!.en!;

export const Route = createFileRoute("/en/services/ai-marketing")({
  head: () =>
    pageHead({
      path: "/en/services/ai-marketing",
      title: c.title,
      description: c.description,
      crumbs: [["Services", "/services"], ["AI & Agentic Marketing", "/en/services/ai-marketing"]],
      schemas: landingSchemas(c),
    }),
  component: () => <LandingPage pageKey="ai-marketing" forceLanguage="en" pathOverride="/en/services/ai-marketing" />,
});
